// extracted by mini-css-extract-plugin
export var chapterTitle = "sidebar-module--chapterTitle---kIyi";
export var fadeAndScaleIn = "sidebar-module--fade-and-scale-in--BLMt-";
export var link = "sidebar-module--link--23Uec";
export var linkActive = "sidebar-module--linkActive--k+8lk";